import API from "./index";
import moment from 'moment'

class IBPService {
  constructor() {
    this.path = `/api/itembempermanente`;
  }

  listaDepreciacaoIbpNaturezaDespesa(id, dataInicial, dataFinal) {

    return API.get(`${this.path}/listaDepreciacaoIbpNaturezaDespesa/${id}`, {
      params: {
        dataInicial: moment(dataInicial, 'YYYY/MM/DD').format('yyyy-MM-DDTHH:mm:ss'),
        dataFinal: moment(dataFinal, 'YYYY/MM/DD').format('yyyy-MM-DDTHH:mm:ss')

      }
    });

  }

  getPageConsultaIBP(parameters){

    return API.get(`api/consultaitembempermanente/getPageConsultaIBP`, {
      params: parameters
    });

  }

  buscarRegistroEntradaView(id){

    return API.get(`${this.path}/buscar-item-reg-entrada-view/${id}`);

  }

}


export default IBPService;
